/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled, { css } from 'styled-components';
import { getDownMedia, getColor } from '../../styles';
import { Text } from '../../components/texts';
import { TableCell } from './TableCell';

export const NameCell = styled(TableCell)<{
  $lineHeight?: number;
}>`
  padding: 10px 12px 8px 4px;
  background-color: #fff;
  white-space: pre-line;

  ${({ $lineHeight }) =>
    !!$lineHeight &&
    css`
      line-height: ${$lineHeight};
    `}

  ${getDownMedia('md')} {
    padding-right: 6px;
    position: sticky;
    left: 0;
    z-index: 1;
  }

  > div {
    min-width: 100px;
    display: inline-flex;
    align-items: center;
  }
`;

export const NameCellText = styled(Text)<{
  $noWrap?: boolean;
}>`
  font-size: 15px;
  line-height: 1;
  ${({ $noWrap = true }) =>
    $noWrap &&
    css`
      white-space: nowrap;
    `};
  color: inherit;
`;

export const NameCellDesc = styled.span<{
  $colorInherit?: boolean;
}>`
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  color: ${({ $colorInherit = false }) =>
    $colorInherit ? 'inherit' : getColor('veniceBlue')};
`;
